// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2zJPd","inputWrap":"Table_inputWrap__39ijd","col":"Table_col__1wJdd","bmiTooltip":"Table_bmiTooltip__2C7cq"};